import { ISelectItem } from '@components/dataEntry/select';

export const MAIN_HOME_SEC_TYPE = {
  LOGO: 'logo',
  MARQUEE: 'marquee',
  SLIDE: 'slide',
  NOTICE: 'notice',
  BANNEER: 'banner',
  POSTINGNOTICE: 'postingnotice',
  MINICALENDAR: 'minicalendar',
  USERLOGIN: 'userlogin',
  DDAYWIDGHET: 'ddaywidget',
  LATEST: 'latest',
  MYROOM: 'myroom',
  CLOCK: 'clock',
  DAILYTODO: 'dailytodo',
  EMPTY: 'empty',
  GALLERY: 'gallery',
  GUESTBOOK: 'guestbook',
  MUSICPLAYER: 'musicplayer',
  MASTERINFO: 'masterinfo',
  MENU: 'menu',
  THREAD: 'thread',
} as const;

export type MAIN_HOME_SEC_TYPE_KEY = keyof typeof MAIN_HOME_SEC_TYPE;

export type MAIN_HOME_SEC_TYPE_VALUE =
  typeof MAIN_HOME_SEC_TYPE[MAIN_HOME_SEC_TYPE_KEY];

export const MAIN_HOME_SEC_TYPE_MAP = {
  [MAIN_HOME_SEC_TYPE.LATEST]: '최신글',
  [MAIN_HOME_SEC_TYPE.SLIDE]: '슬라이드 이미지',
  [MAIN_HOME_SEC_TYPE.NOTICE]: '메인 공지',
  [MAIN_HOME_SEC_TYPE.POSTINGNOTICE]: '포스팅-공지',
  [MAIN_HOME_SEC_TYPE.MARQUEE]: '움직이는 한줄 텍스트',
  [MAIN_HOME_SEC_TYPE.BANNEER]: '배너란',
  [MAIN_HOME_SEC_TYPE.LOGO]: '로고',
  [MAIN_HOME_SEC_TYPE.MINICALENDAR]: '미니 캘린더',
  [MAIN_HOME_SEC_TYPE.GALLERY]: '미니 갤러리',
  [MAIN_HOME_SEC_TYPE.GUESTBOOK]: '미니 방명록',
  [MAIN_HOME_SEC_TYPE.USERLOGIN]: '로그인/유저 정보',
  [MAIN_HOME_SEC_TYPE.MASTERINFO]: '마스터(주인장) 정보',
  [MAIN_HOME_SEC_TYPE.DDAYWIDGHET]: '디데이위젯',
  [MAIN_HOME_SEC_TYPE.MYROOM]: '스티커보드',
  [MAIN_HOME_SEC_TYPE.CLOCK]: '시계',
  [MAIN_HOME_SEC_TYPE.DAILYTODO]: '데일리 투두리스트',
  [MAIN_HOME_SEC_TYPE.MUSICPLAYER]: '음악 플레이어',
  [MAIN_HOME_SEC_TYPE.EMPTY]: '여백(빈공간)',
  [MAIN_HOME_SEC_TYPE.THREAD]: '스레드',
};

export const mainHomeTypeList = Object.keys(MAIN_HOME_SEC_TYPE_MAP).map(
  (key) => {
    return {
      key: key,
      value: MAIN_HOME_SEC_TYPE_MAP[key],
    };
  },
);

export const MAINHOME_TYPE_LIST: ISelectItem[] = Object.keys(
  MAIN_HOME_SEC_TYPE_MAP,
).map((key) => {
  const value =
    MAIN_HOME_SEC_TYPE_MAP[key as keyof typeof MAIN_HOME_SEC_TYPE_MAP];

  return {
    key: key,
    value: value,
    order: Object.keys(MAIN_HOME_SEC_TYPE_MAP).indexOf(key), // 선택적으로 순서 추가
  };
});

export interface IMainGridCell {
  row: number;
  col: number;
}

export interface IMainGridGroupData {
  color: string;
  status: MAIN_HOME_SEC_TYPE_VALUE | string; // 상태 (예: 'logo', 'slide' 등)
  cells: IMainGridCell[];
  order: number;
}

export interface IMainGrid {
  [key: string]: IMainGridGroupData;
}

export const initialGridSize = {
  rows: 6,
  cols: 7,
};

export const initialCustomGrid: IMainGrid = {
  '#FF5733': {
    order: 0,
    color: '#FF5733',
    status: 'logo',
    cells: [
      { row: 0, col: 0 },
      { row: 0, col: 1 },
      { row: 0, col: 2 },
      { row: 0, col: 3 },
      { row: 0, col: 4 },
      { row: 0, col: 5 },
      { row: 0, col: 6 },
    ],
  },
  '#33FF57': {
    order: 1,
    color: '#33FF57',
    status: 'slide',
    cells: [
      { row: 1, col: 0 },
      { row: 1, col: 1 },
      { row: 1, col: 2 },
      { row: 1, col: 3 },
      { row: 1, col: 4 },
      { row: 1, col: 5 },
      { row: 1, col: 6 },
      { row: 2, col: 0 },
      { row: 2, col: 1 },
      { row: 2, col: 2 },
      { row: 2, col: 3 },
      { row: 2, col: 4 },
      { row: 2, col: 5 },
      { row: 2, col: 6 },
    ],
  },
  '#5788FF': {
    order: 2,
    color: '#5788FF',
    status: 'marquee',
    cells: [
      { row: 3, col: 0 },
      { row: 3, col: 1 },
      { row: 3, col: 2 },
      { row: 3, col: 3 },
      { row: 3, col: 4 },
      { row: 3, col: 5 },
      { row: 3, col: 6 },
    ],
  },
  '#417505': {
    order: 3,
    color: '#417505',
    status: 'xwidget',
    cells: [
      { row: 4, col: 0 },
      { row: 4, col: 1 },
      { row: 5, col: 0 },
      { row: 5, col: 1 },
    ],
  },
  '#FFFF33': {
    order: 4,
    color: '#FFFF33',
    status: 'minicalendar',
    cells: [
      { row: 4, col: 2 },
      { row: 4, col: 3 },
      { row: 4, col: 4 },
      { row: 5, col: 2 },
      { row: 5, col: 3 },
      { row: 5, col: 4 },
    ],
  },
  '#FF33FF': {
    order: 5,
    color: '#FF33FF',
    status: 'userlogin',
    cells: [
      { row: 4, col: 5 },
      { row: 4, col: 6 },
    ],
  },
  '#f5a623': {
    order: 6,
    color: '#f5a623',
    status: 'banner',
    cells: [
      { row: 5, col: 5 },
      { row: 5, col: 6 },
    ],
  },
};
